<template>
    <div v-if="packages != null && packages.length > 0">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-for="package in packages" v-if="package.ranges.length > 0">
            <div class="box-layout-inner">
                <div class="title-block">
                    {{ package.name }}
                </div>

                <div class="content-block hidden-xs" v-html="package.description">
                </div>

                <ul class="content-links">
                    <li v-for="range in package.ranges">
                        <a @click="progress(range, package)">{{ range.title }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <div class="box-layout-inner">
            <p class="text-center" v-if="loading"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                packages: null,
                loading: true,
                xmas_exception: false
            }
        },
        methods: {
            progress: function (range, agePackage) {
                range.package = agePackage;
                this.$emit('updatebuilder', {
                    method: 'append',
                    data: {
                        age: range.end_age,
                        min_age: range.start_age
                    }
                });

                // if(this.xmas_exception && range.start_age == 5 && range.end_age == 14) {
                //     // Special case for Christmas 2025 age range for St.Cedds
                //     this.$router.push({
                //         name: 'booking.packages',
                //         query: {age: range.end_age, days: range.package.individual_days}
                //     });
                //     return;
                // }

                if (range.title.includes('5 - 14 years old (Full Week)') && range.start_age == 5 && range.end_age == 14) {
                    // Special case for weekly MA packages
                     this.$router.push({
                        name: 'booking.weeks',
                        query: {age: range.end_age, min_age: range.start_age}
                    });
                    return;
                }

                if(range.package.individual_days) {
                    this.$router.push({
                        name: 'booking.packages',
                        query: {age: range.end_age, days: range.package.individual_days}
                    });
                } else {
                    this.$router.push({name: 'booking.weeks', query: {age: range.end_age, min_age: range.start_age}});
                }
            },
            update: function () {
                /**
                 * Setting the headers
                 **/
                this.$root.headers = {
                    title: this.$root.locale.miscellaneous.page_headings.booking.select_age,
                    breadcrumbs: [],
                    allow_change: true,
                }

                this.$root.alert(this.$root.locale.miscellaneous.blank_screen_help_msg);

                /**
                 * Getting all the venues to fill the select dropdown to select a venue.
                 */
                axios.get('camp-booking/age-ranges?venue_id='+this.$route.params.venueId).then(response => {
                    this.packages = response.data.data;
                    this.loading = false;
                    if(this.packages[0].ranges.length == 0 && this.packages[1].ranges.length == 0)
                        this.$root.alert(this.locale.text_empty);

                    // Special case for weekly MA packages (moving age range 5-14 from package 2 to package 1)
                    if(this.packages[1].ranges.length > 0) {
                        const rangeIndex = this.packages[1].ranges.findIndex(r => r.start_age === 5);
                        if(rangeIndex !== -1) {
                            const range = this.packages[1].ranges.splice(rangeIndex, 1)[0];
                            range['start_age'] = 5;
                            range['end_age'] = 14;
                            range['title'] = '5 - 14 years old (Full Week)';
                            this.packages[0].ranges.push(range);
                            this.xmas_exception = true;
                        }
                    }

                    if(this.$route.params.venueId == 283) {
                        // Special case for University of Stirling with The Weekender programme instead of Rookie Academy
                        this.packages[1].name = 'The Weekender';
                        this.packages[1].description = 'The Weekender is designed for young people aged 14 - 17 of RNRM and RAF families and offers an activity and development residential weekend at the world-class Stirling University. The programme focuses on being active, having fun, and learning with others, with the aim of developing confidence, skills, a love for being active, new friendships and a sense of community.';
                    }
                })
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.booking.ages;
            }
        },
        watch: {
            '$route' (to) {
                this.page = to.name;
                this.builder = this.$root.builder;

                this.update();
            }
        },
        created() {
            this.update();

            // Clear the individualDaysSelected from localStorage when the component is created
            if(localStorage.getItem('individualDaysSelected')) {
                localStorage.removeItem('individualDaysSelected');
            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// AgeRanges.vue?49340084